import React, { Component } from 'react';
import Config from 'Config';
import { Col, FormGroup, ControlLabel, HelpBlock } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha';

class Captcha extends Component {
	componentDidMount() {
		if (this.props.size === 'invisible') {
			this.captcha.execute();
		}
	}

	render() {
		const { size = 'normal', badge = 'bottomright', labelCol = 3, valueCol = 9, horizontal, required, input, label, help, meta: { touched, error, warning } } = this.props;

		const validationState = touched && (error && "error") || (warning && "warning") || null;

		const formControl = <ReCAPTCHA
			ref={(el) => { this.captcha = el; }}
			sitekey={Config.reCaptchaSiteKey}
			size={size}
			badge={badge}
			onChange={input.onChange}
		/>;

		const errorBlock = touched && (error || warning) && <HelpBlock>{error || warning}</HelpBlock>;
		const helpBlock = help && <HelpBlock>{help}</HelpBlock>;
		const labelHint = required && <em style={{ color: '#D62229' }}>*</em>;

		if (horizontal) {
			return (
				<FormGroup validationState={validationState} className='row'>
					<Col componentClass={ControlLabel} sm={labelCol}>
						{label}{labelHint}
					</Col>
					<Col sm={valueCol}>
						{formControl}
						{errorBlock}
						{helpBlock}
					</Col>
				</FormGroup>);
		}

		return (
			<FormGroup validationState={validationState}>
				<ControlLabel>{label}{labelHint}</ControlLabel>
				{formControl}
				{errorBlock}
				{helpBlock}
			</FormGroup>
		);
	}
}

export default Captcha;